import { Campaign } from '@interfaces'
import useTopToastNotification from '@hooks/useTopToastNotification'

export const useSharePageHandlers = (campaign: Campaign) => {
  const { notification } = useTopToastNotification()

  const handleCopyLink = async (): Promise<void> => {
    const viewUrl = `${campaign?.shareUrl}${campaign?.shareId}`
    try {
      await navigator.clipboard.writeText(viewUrl)
      notification('Video link has been copied!')
    } catch (err) {
      console.error('Failed to copy text: ', err)
      notification('Failed to copy link!')
    }
  }

  const handleDownload = async (): Promise<void> => {
    try {
      const { meta: { video, heading1, name } } = campaign
  
      const isMp4Ready = video?.muxMP4Ready || false
      const mp4Url = video?.sources?.find(source => source.type === 'video/mp4')?.src
      const videoName = heading1 || name || video?.name || ''
  
      const isReadyToDownload = isMp4Ready && mp4Url && videoName
  
      if (!isReadyToDownload) {
        notification('Video is not ready for download')
        return
      }
  
      const encodedVideoName = encodeURIComponent(videoName)
      const downloadUrl = `${mp4Url}?download=${encodedVideoName}`
      window.open(downloadUrl, '_self')
      notification('Your video is downloading!')
      return
    } catch (error) {
      console.error('Failed to download video: ', error)
      notification('Failed to download video!')
    }
  }

  return {
    handleCopyLink,
    handleDownload
  }
}